<template>
  <div class="content-experience-search-input">
    <Icon
      icon="magnifying-glass"
      prefix="fas"
    />
    <input
      v-model="searchTerm"
      type="text"
      name="q"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  placeholder?: string
}>()

const searchTerm = defineModel<string>()
</script>

<style>
.content-experience-search-input {
  @apply flex w-full items-center rounded-md ring-1 ring-inset ring-input focus-within:ring-primary focus-within:hover:ring-primary md:max-w-60;

  > .icon {
    @apply pl-4 text-gray-300;
  }

  > input {
    @apply form-input grow border-none bg-transparent py-3 pr-4 text-sm focus:outline-none focus:ring-0;
  }
}
</style>
